<template>
  <div class="field">
    <label class="label">เลือกจังหวัด</label>

    <div class="control has-icons-left">
      <div class="select is-fullwidth is-rounded is-primary">
        <select
          :value="modelValue"
          @change="$emit('update:modelValue', $event.target.value)"
        >
          <option v-for="(value, key) in provinces" :key="key" :value="key">
            {{ value.name }}
          </option>
        </select>
      </div>

      <span class="icon is-left">
        <i class="fas fa-map-marker-alt"></i>
      </span>
    </div>
  </div>
</template>

<script setup>
/* global defineProps, defineEmits */
import { provinces } from "../config/provinces";

defineProps(["modelValue"]);
defineEmits(["update:modelValue"]);
</script>
